function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#012A52",
  rx: 2.462
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M18.575 12.276c.683 0 1.265.582 1.265 1.266 0 .683-.51 1.25-1.265 1.25l-2.022-.028 2.909 2.923c.509.495.509 1.28 0 1.79-.495.508-1.28.508-1.79 0l-2.88-2.88v1.978c0 .741-.567 1.265-1.265 1.265a1.283 1.283 0 0 1-1.28-1.236v-2.531c0-.524.35-1.033.815-1.193 1.338-.48 1.789-1.775 1.789-1.775.189-.48.654-.829 1.193-.829zm-10.619-.014c.524 0 1.019.334 1.193.8.451 1.353 1.746 1.803 1.746 1.803.494.175.829.626.814 1.193v2.517c0 .683-.553 1.25-1.265 1.25-.684 0-1.251-.45-1.222-1.25l.029-2.022-2.924 2.923c-.494.51-1.323.51-1.789 0-.509-.494-.509-1.323 0-1.789l2.866-2.894H5.44a1.276 1.276 0 0 1-1.265-1.266c0-.683.552-1.265 1.265-1.265zm5.586-8.102c.683 0 1.25.51 1.25 1.25l-.028 2.023 2.909-2.88c.494-.51 1.28-.51 1.789 0a1.255 1.255 0 0 1 0 1.803l-2.866 2.866h2.008c.683 0 1.265.582 1.265 1.265 0 .684-.567 1.266-1.265 1.266h-2.531c-.524 0-1.033-.335-1.193-.8-.48-1.353-1.775-1.818-1.775-1.818-.465-.204-.829-.64-.829-1.193V5.41c0-.684.568-1.251 1.266-1.251zm-9.033.364a1.239 1.239 0 0 1 1.79 0l2.908 2.894V5.425c0-.683.553-1.265 1.266-1.265.683 0 1.25.567 1.25 1.265v2.531c0 .524-.334 1.033-.8 1.193-1.338.48-1.788 1.775-1.788 1.775-.19.48-.655.829-1.193.829H5.41c-.684 0-1.266-.582-1.266-1.28 0-.713.466-1.251 1.266-1.251l2.022.014-2.924-2.923a1.264 1.264 0 0 1 0-1.79z"
}));

var SvgIcRbs = function SvgIcRbs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    style: {
      background: "#fff"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcRbs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_rbs.c0c64cec.svg";
export { ForwardRef as ReactComponent };